import { NavItem } from "../nav-item/nav-item";
export const navItems: NavItem[] = [
  {
    navCap: 'Menú',
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    bgcolor: 'primary',
    route: '/client/dashboard',
  },
  {
    displayName: 'Contactos',
    iconName: 'address-book',
    bgcolor: 'primary',
    route: '/client/contactos',
  },
  {
    displayName: 'Mi Red',
    iconName: 'affiliate',
    bgcolor: 'primary',
    route: '/client/network',
  },
  {
    displayName: 'Ficha Motor',
    iconName: 'car',
    bgcolor: 'primary',
    route: '/client/ficha-motor',
  },
  {
    displayName: 'Beneficios',
    iconName: 'gift',
    bgcolor: 'primary',
    route: '/client/beneficios',
  },
];
